import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { createFundContribution, updateFundContribution } from '../../../api/ClubFundAPI';
import { handleApiError } from'../../../api/risapi';

const AddIncomeForm = ({ editingRecord, members, sponsors, incomeHeads, onSuccess, onCancel }) => {
    const isEditMode = !!editingRecord;
    const initialFormState = {
        contributable_type: 'user', contributor_id: null, head_of_account_id: null,
        amount: '', payment_method: 'Cash', contribution_date: new Date().toISOString().slice(0, 10), remarks: ''
    };
    const [formData, setFormData] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isEditMode && editingRecord) {
            setFormData({
                contributable_type: editingRecord.contributable_type === 'App\\Models\\User' ? 'user' : 'sponsor',
                contributor_id: { value: editingRecord.contributable_id, label: editingRecord.contributable?.name },
                head_of_account_id: { value: editingRecord.head_of_account_id, label: editingRecord.head_of_account?.name },
                amount: editingRecord.amount,
                payment_method: editingRecord.payment_method,
                contribution_date: editingRecord.contribution_date,
                remarks: editingRecord.remarks,
            });
        }
    }, [editingRecord, isEditMode]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handleSelectChange = (name, selectedOption) => {
        setFormData(prev => ({ ...prev, [name]: selectedOption }));
    };

    const handleSubmit = () => {
        setIsSaving(true);
        const apiCall = isEditMode ? updateFundContribution : createFundContribution;
        const payload = {
            ...formData,
            id: editingRecord?.id,
            contributable_id: formData.contributor_id?.value,
            head_of_account_id: formData.head_of_account_id?.value
        };
        apiCall(payload, (response) => {
            setIsSaving(false);
            if (response.contribution) {
                Swal.fire('Success!', `Income ${isEditMode ? 'updated' : 'recorded'} successfully!`, 'success');
                onSuccess();
            } else {
                handleApiError(response, setErrors);
                Swal.fire('Error!', 'Please check the form for errors.', 'error');
            }
        });
    };

    const contributorOptions = formData.contributable_type === 'user' ? members.map(m => ({ value: m.id, label: m.name })) : sponsors.map(s => ({ value: s.id, label: s.name }));
    const headOptions = incomeHeads.map(h => ({ value: h.id, label: h.name }));
    const paymentMethodOptions = ['Cash', 'Bank Transfer', 'Online Payment'];

    return (
        <div className="col-12">
            <div className="card mb-4">
                <div className="card-header d-flex justify-content-between">
                    <h5>{isEditMode ? 'Edit' : 'Record New'} Income</h5>
                    <button type="button" className="btn-close" onClick={onCancel}></button>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 mb-3"><label className="form-label">Contribution Type</label><div className="d-flex"><div className="form-check me-3"><input type="radio" className="form-check-input" id="type_member" name="contributable_type" value="user" checked={formData.contributable_type === 'user'} onChange={handleInputChange} /><label htmlFor="type_member">Member</label></div><div className="form-check"><input type="radio" className="form-check-input" id="type_sponsor" name="contributable_type" value="sponsor" checked={formData.contributable_type === 'sponsor'} onChange={handleInputChange} /><label htmlFor="type_sponsor">Sponsor</label></div></div></div>
                        <div className="col-md-6 mb-3"><label className="form-label">Contributor *</label><Select options={contributorOptions} value={formData.contributor_id} onChange={(opt) => handleSelectChange('contributor_id', opt)} />{errors.contributable_id && <div className="text-danger small">{errors.contributable_id}</div>}</div>
                        <div className="col-md-6 mb-3"><label className="form-label">Head of Account (Income) *</label><Select options={headOptions} value={formData.head_of_account_id} onChange={(opt) => handleSelectChange('head_of_account_id', opt)} />{errors.head_of_account_id && <div className="text-danger small">{errors.head_of_account_id}</div>}</div>
                        <div className="col-md-6 mb-3"><label className="form-label">Amount (₹) *</label><input type="number" className="form-control" name="amount" value={formData.amount} onChange={handleInputChange} />{errors.amount && <div className="text-danger small">{errors.amount}</div>}</div>
                        <div className="col-md-6 mb-3"><label className="form-label">Payment Method *</label><select className="form-select" name="payment_method" value={formData.payment_method} onChange={handleInputChange}>{paymentMethodOptions.map(method => <option key={method} value={method}>{method}</option>)}</select>{errors.payment_method && <div className="text-danger small">{errors.payment_method}</div>}</div>
                        <div className="col-md-6 mb-3"><label className="form-label">Contribution Date *</label><input type="date" className="form-control" name="contribution_date" value={formData.contribution_date} onChange={handleInputChange} />{errors.contribution_date && <div className="text-danger small">{errors.contribution_date}</div>}</div>
                        <div className="col-12 mb-3"><label className="form-label">Remarks</label><input type="text" className="form-control" name="remarks" value={formData.remarks} onChange={handleInputChange} /></div>
                    </div>
                </div>
                <div className="card-footer text-end">
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={isSaving}>
                        {isSaving ? 'Saving...' : (isEditMode ? 'Update Income' : 'Save Income')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddIncomeForm;
